var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('v-card',{staticClass:"rounded-lg pa-7 mt-7",attrs:{"flat":""}},[_c('Tablepersonal')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }